import React from "react";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import WebLayout from "../components/WebLayout";
import PostList from "../components/PostList";

const GET_STORIES = gql`
  query GetStories {
    articles(category: STORY) {
      id
      title
      source
      picture {
        filename
        mimetype
        encoding
        location
      }
      description
      content
      createdAt
    }
  }
`;

export default function Story() {
  const { data } = useQuery(GET_STORIES);
  return (
    <WebLayout>
      {data && <PostList data={data.articles} />}
    </WebLayout>
  );
}
